import React, { Component } from "react";
import { connect } from "react-redux";
import { setRmtPrtcpDvc } from "store/slice/videoConsultation-slice";

class Track extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }
  componentDidMount() {
    if (this.props.track !== null && this.props.track.kind != "data") {
      const child = this.props.track.attach();
      // this.ref.current.classList.add(this.props.track.kind);
      this.ref.current.appendChild(child);
    }
    if (
      this.props.track.kind === "video" &&
      this.props.localParticipant === "notLocalParticipant"
    ) {
      this.props.track.on("dimensionsChanged", () => {
        if (this.props.track?.dimensions?.width < 500) {
          this.props.setRmtPrtcpDvc("rmt_prtcp_mob");
        } else {
          this.props.setRmtPrtcpDvc("rmt_prtcp_web");
        }
      });
    }
  }

  componentWillUnmount() {
    if (this.props.track.kind == "video") {
      this.props.setRmtPrtcpDvc("rmt_prtcp_web");
    }
  }

  render() {
    return (
      <div
        className={`track ${this.props.track.kind} ${
          this.props.videoFullScreen ? "fullscreen" : "exitscreen"
        }`}
        ref={this.ref}
      ></div>
    );
  }
}

const mapDispatchToProps = {
  setRmtPrtcpDvc,
};

const mapStateToProps = (state) => {
  return {
    videoFullScreen: state.videoConsultationReducer.videoFullScreen,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Track);
